import { useOverviewContext } from "../context/OverviewContext";
import { FooterMobile } from "../Layout/FooterMobile";
import Header from "../Layout/Header";
import Sidebar from "../Layout/Sidebar";
import config from '../config';
import HeroBanner from '../components/HeroBanner';
import Breadcrumbs from "../components/Breadcrumb";
import VidyardPlayer from "../components/VidyardPlayer";
import imgCommunitys from "../assets/images/banners/community-student-banner.jpg";
import imgCommunitylc from "../assets/images/banners/community-lc-banner.jpg";
import imgIconchat from "../assets/images/icon_chat.svg";
import imgIconjoin from "../assets/images/icon_join.svg";
import imgLcc from "../assets/images/lcc.jpg";
import ButtonLink from "../components/ButtonLink";
import { useToolSettings } from "../context/ToolSettingsContext";
import { getActiveToolIDs, shouldShowK12Zone, shouldShowLearningCoachCommunity } from "../utils/menuUtils";
export function Community() {
const { HOME, LC_COMMUNITY, K12ZONE } = config.app.routes;
const breadcrumbItems = [
    { label: "Home", path: HOME },
    { label: "Community" }, 
];
const {userRoleVal, formattedStudentNames} = useOverviewContext();
// Get tool settings from context
const { toolSettings } = useToolSettings();
const activeToolIDs = getActiveToolIDs(toolSettings);
const showLearningCoachCommunity = shouldShowLearningCoachCommunity(userRoleVal, activeToolIDs);
const showK12Zone = shouldShowK12Zone(userRoleVal, activeToolIDs);
console.log(showLearningCoachCommunity, showK12Zone);

return (
    <>
    <div className="home-layout">
        <div className="sidebar-wrapper">
        <Sidebar />
        </div>
        <div className="body-wrapper-content">
        <div className="row">
            <div className="col-12">
                <Header />
                <main id="main" role="main">
                    <div className="main-content">
                        <div className="row">
                            <div className="col-12">
                                <Breadcrumbs items={breadcrumbItems} />  
                            </div>
                        </div>

                        {userRoleVal?.toUpperCase() == "STUDENT" && ( 
                        <HeroBanner
                            title="Community"
                            subtitle="Online school is more social than ever! Find new ways to connect here."
                            imageUrl= {imgCommunitys}
                            altText="Community Banner"
                            customClass="bg-color-blue-t1-community common-banner-bg-white"
                        />
                        )}
                        
                        {userRoleVal?.toUpperCase() == "LEARNING_COACH" && (
                        <HeroBanner
                            title="Community"
                            subtitle="Online school is more social than ever! Find new ways to connect here."
                            imageUrl={imgCommunitylc}
                            altText="Community LC Banner"
                            customClass="bg-color-blue-t1-community common-banner-bg-white"
                        />
                        )}   

                        {userRoleVal?.toUpperCase() == "STUDENT" && ( 
                        <div className="wp-block-columns is-layout-flex wp-container-core-columns-is-layout-5 wp-block-columns-is-layout-flex">
                            <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow">
                                <div className="wp-block-k12-user-role-content-wrapper">
                                    <div className="wp-block-k12-section container-fluid  bg-transparent p-5">
                                        <div className="row"><div className="col-12 g-0">
                                            <h2 className="wp-block-heading">The Social Side of Online School&nbsp;</h2>
                                            <p className="mb-4"><strong>Make connections, explore interests, and pursue passions online and in person with social events and activities! Check with your school for full details.</strong></p>

                                            <div className="wp-block-columns gap-2 is-layout-flex wp-container-core-columns-is-layout-2 wp-block-columns-is-layout-flex align-items-start">
                                                <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow" style={{ flexBasis: "32px" }}>
                                                    <figure className="wp-block-image size-large is-resized"><img
                                                        decoding="async"
                                                        width="24"
                                                        height="24"
                                                        src={imgIconchat}
                                                        alt=""
                                                        className="wp-image-452"
                                                        style={{ width: '32px' }}
                                                        /></figure>
                                                </div>

                                                <div className="wp-block-column mb-2 is-layout-flow wp-block-column-is-layout-flow">
                                                    <h3 className="wp-block-heading  mb-1">Chat with Friends</h3>
                                                    <p>Spend a little time checking in with peers and sharing your experiences.</p>
                                                </div>
                                            </div>

                                            <div className="wp-block-columns gap-2 is-layout-flex wp-container-core-columns-is-layout-3 wp-block-columns-is-layout-flex align-items-start">
                                                <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow" style={{ flexBasis: "32px" }}>
                                                    <figure className="wp-block-image size-large is-resized">
                                                    <img
                                                        decoding="async"
                                                        width="24"
                                                        height="24"
                                                        src={imgIconjoin}
                                                        alt=""
                                                        className="wp-image-451"
                                                        style={{ width: '32px' }}
                                                        />
                                                    </figure>
                                                </div>

                                                <div className="wp-block-column mb-2 is-layout-flow wp-block-column-is-layout-flow">
                                                    <h3 className="wp-block-heading  mb-1">Join Clubs and Activities</h3>
                                                    <p>Find friends who share your interests and have fun exploring them together!</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>  
                         )} 

                        {userRoleVal?.toUpperCase() == "STUDENT" && ( 
                        <div className="wp-block-k12-section container-fluid  bg-color-light-gray-3 p-3rem k12-zone-block">
                            <div className="row">
                                <div className="col-12">
                                    <div className="wp-block-columns is-layout-flex wp-container-core-columns-is-layout-4 wp-block-columns-is-layout-flex">
                                        <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow">
                                            <h2 className="wp-block-heading"><strong>K12 Zone</strong></h2>
                                            <p>Ready to meet your new classmates? Explore our virtual, open-world campus where kids hang out, chat with friends, and join clubs and activities in a safe, welcoming environment.</p>
                                            <div className="wp-block-buttons is-layout-flex wp-block-buttons-is-layout-flex">
                                                <div className="wp-block-button btn-primary">
                                                    {/* <a className="wp-block-button__link wp-element-button" href="https://welcome.k12.com/community/k12-zone/">Learn More About the K12 Zone</a> */}
                                                    <ButtonLink
                                                    urlKey="K12ZONE"
                                                    label="Learn More About the K12 Zone"
                                                    className="wp-block-button__link wp-element-button"
                                                    source="routes"
                                                    />

                                                </div>
                                            </div>
                                        </div>

                                        <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow">
                                            <div className="wp-block-k12-video-block" style={{ display: "block" }}>
                                                <div className="row">
                                                    <div style={{ display: "block", opacity: 1 }}>
                                                        <VidyardPlayer uuid="FLbQGoUFC2UBVv7uEay7WY" type="lightbox" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        )} 

                        {userRoleVal?.toUpperCase() == "LEARNING_COACH" && (                                                    
                        <div className="wp-block-k12-user-role-content-wrapper chkLC">
                            <div className="wp-block-k12-section container-fluid bg-color-transparent">
                                <div className="row">
                                <div className="col-12 g-0">
                                    <div className="wp-block-columns is-layout-flex wp-container-core-columns-is-layout-1 wp-block-columns-is-layout-flex">
                                    
                                    {/* Left Column */}
                                    {showLearningCoachCommunity && (
                                    <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow">
                                        <div className="wp-block-k12-section container-fluid bg-color-light-gray-3 p-2rem mb-4 mb-md-0 lc-community-block">
                                        <div className="row">
                                            <div className="col-12">
                                            <figure className="wp-block-image size-large">
                                                <img
                                                decoding="async"
                                                width="1024"
                                                height="640"
                                                src={imgLcc}
                                                alt="map image"
                                                className="wp-image-83228"
                                                sizes="(max-width: 1024px) 100vw, 1024px"
                                                />
                                            </figure>

                                            <div className="wp-block-k12-landing-community btn-primary m-0">
                                                <div className="row g-0 map-top">
                                                <div className="community-map-wrapper bg-color-white">
                                                    <div className="col-md-12 col-xxl-12">
                                                    <div className="body">
                                                        <h3>
                                                        Learning Coach <strong>Community</strong>
                                                        </h3>
                                                        <p>
                                                        Join the Learning Coach Community, an online community built just for you and your
                                                        fellow Learning Coaches! You’ll be able to access support and resources specific to
                                                        your student, share tips and tools for online school, make friends, and cheer on your
                                                        peers all in one place.
                                                        <br />
                                                        <br />
                                                        {/* <a href="https://welcome.k12.com/community/learning-coach-community/">
                                                            Learn More About the LC Community
                                                        </a> */}
                                                        
                                                        <ButtonLink
                                                        urlKey="LC_COMMUNITY"
                                                        label="Learn More About the LC Community"
                                                        className="wp-block-button__link wp-element-button"
                                                        source="routes"
                                                        />
                                                        
                                                        </p>
                                                    </div>
                                                    </div>
                                                </div>
                                                </div>
                                            </div>

                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    )}

                                    {/* Right Column */}
                                    {showK12Zone && ( 
                                    <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow">
                                        <div className="wp-block-k12-section container-fluid bg-color-light-gray-3 p-5 mb-md-0">
                                        <div className="row">
                                            <div className="col-12 g-0">
                                                <div className="wp-block-k12-video-block mb-3" style={{ display: "block" }}>
                                                    <div className="row">
                                                        <div style={{ display: "block", opacity: 1 }}>
                                                            <VidyardPlayer uuid="FLbQGoUFC2UBVv7uEay7WY" type="lightbox" /> 
                                                        </div>
                                                    </div>
                                                </div>
                                            <div className="wp-block-k12-section container-fluid bg-transparent ps-3rem">
                                                <div className="row">
                                                <div className="col-12 g-0">
                                                    <h3 className="wp-block-heading">K12 Zone</h3>
                                                    <p>
                                                    Wondering how students get social? In the K12 Zone! Our virtual campus where students hang
                                                    out, chat with friends, and join clubs and activities in a safe, welcoming environment.
                                                    </p>
                                                    <div className="wp-block-buttons is-layout-flex wp-block-buttons-is-layout-flex">
                                                    <div className="wp-block-button btn-primary">
                                                        {/* <a
                                                        className="wp-block-button__link wp-element-button"
                                                        href="https://welcome.k12.com/community/k12-zone/"
                                                        >
                                                        Learn More About the K12 Zone&nbsp;
                                                        </a> */}
                                                        <ButtonLink
                                                        urlKey="K12ZONE"
                                                        label="Learn More About the K12 Zone"
                                                        className="wp-block-button__link wp-element-button"
                                                        source="routes"
                                                        />

                                                    </div>
                                                    </div>
                                                </div>
                                                </div>
                                            </div>

                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    )}
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>                                                    
                        )}
                    </div>
                </main>
            </div>
        </div>

        </div>
        <FooterMobile />
    </div>
    </>   
);
}